<template>
  <div>
    <div class="center-menu-desktop" @resize="handleWidth" v-if="isMobile >= 1024">
      <ul class="hero-menu__list center-menu__list hero-menu__nav">
        <li v-for="(item, index) in menuItems.items" :key="item.id" :id="'menuitem-' + (item.id)"
          @click="itemClicked(item.id, item)"
          :class="item.current ? 'center-menu__item hero-menu__item active' : 'center-menu__item hero-menu__item'"
          :aria-expanded="open">
          <a :href="item.url" v-if="index === 0">{{ item.name }}</a>
          <span v-else>{{ item.name }}</span>
          <span v-if="!item.current && index !== 0" class="the-center-nav-accordion__group-button">
            <svg aria-hidden="true" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"
              class="base-symbol the-center-accordion__button-icon">
              <path d="M11 5H7V1H5v4H1v2h4v4h2V7h4V5z"></path>
            </svg>
          </span>
        </li>
      </ul>
    <transition enter-active-class="wrapper" leave-active-class="no-wrapper">
      <div class="link-group__featured-row banner-links__header-container center-open-menu"
        v-if="open && Object.keys(activeMenu.children).length !== 0">
        <div class="link-group__featured-inner center-open-inner">
          <div class="link-group__featured-inner-inner center-open-child">
            <ul class="link-group__featured-link center-child-items">
              <li class="link-group__link-item center-child-link" v-for="subMenuItem in activeMenu.children">
                <a :href="subMenuItem.url" target="_self" rel="noopener noreferrer"
                  :class="'base-cta-featured' + (subMenuItem.current ? ' active' : ' nonactive')">
                  {{ subMenuItem.name }}
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-9.811 -6.439 23.62 12.12" width="25px"
                    height="25px">
                    <path
                      d="M7.75-6.439l-2.121 2.121 3.439 3.439H-9.811v1h18.879l-3.439 3.44 2.121 2.121 6.061-6.061-6.061-6.06z"
                      fill="#d43d21" />
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </transition>

    <div class="cookie-trail-lib" v-if="cookieTrail.length >= 4 && !open">
      <div v-for="(item, index) in menuItems.items" class="cookie-trail-item" v-if="index <= 4">
        <span v-if="parentContainer === item.name">
          <svg xmlns="http://www.w3.org/2000/svg" id="arrowArm" viewBox="0 0 23 28.22">
            <polygon class="cls-1"
              points="18.36 22.99 15.5 26 18 28.22 23 22.72 18 17.22 15.5 19.29 18.34 22.45 .51 22.47 .51 0 0 0 0 23.01 18.36 22.99"
              fill="#01246a" />
          </svg> {{ cookieLink }}
        </span>
      </div>
    </div>
  </div>
    <div v-else>
      <AccordionContainer class="center-menu-mobile">
        <AccordionContainerHeaderButton controls="mobile-center-menu-main" id="mobile-center-menu-button"
          class="mobile-center-menu-main-button" @mobile-click="handleMobileClick">
          <span style="pointer-events: none;">{{ menuTitle }}<disclosure-button class="the-nav__button center-menu-button"
              disclosure-id="the-mobile-nav-disclosure" id="the-mobile-nav-disclosure" style="pointer-events: none">
              <discernible-content>Toggle Navigation Menu</discernible-content>
              <img aria-hidden="true" src="/wp-content/themes/macalester-2020/dist/svgs/menu-lines.svg"
                class="the-nav__button-svg the-nav__button-svg--menu" alt="">
              <img aria-hidden="true" src="/wp-content/themes/macalester-2020/dist/svgs/icon-close.svg"
                class="the-nav__button-svg the-nav__button-svg--close" alt="">
            </disclosure-button></span>
        </AccordionContainerHeaderButton>

        <div class="mainhourWrapper center-nav-hours" v-if="hourBlocks.length > 0">
          <p class="hours-block-heading">Hours</p>
          <div class="hourBlockWrapper" v-for="block in hourBlocks" :key="block.section_title">
            <span class="hour_block_title">{{ block.section_title }}</span>
            <div class="detailWrapper">
              <span :class="hourBlock.is_open ? 'open' : 'closed'">{{ hourBlock.is_open ? 'open' : 'closed' }}</span>
              <span>
                <template v-if="hourBlock.is_open">until {{ block.office_hour_end_time }}</template>
                <template v-else>opens {{ block.office_hour_start_time }}</template>
              </span>
            </div>
          </div>
        </div>

        <AccordionContainerPanel id="mobile-center-menu-main" ref="menuPanel">
          <div v-for="(item, index) in menuItems.items" :key="item.id" class="accordion-wrapper"
            :style="{ textDecoration: item.children.length <= 0 ? 'underline' : '' }">
            <a v-if="item.children.length === 0" :href="item.url">
              <AccordionContainerHeaderButton class="mobile-center-menu-mainItem"
                :id="'menu-sub-item-button' + item.id" style="text-decoration: underline;">
                <div class="button-wrapper">
                  {{ item.name }}
                  <svg v-if="item.current" xmlns="http://www.w3.org/2000/svg" viewBox="-9.811 -6.439 23.62 12.12"
                    width="25px" height="25px">
                    <path
                      d="M7.75-6.439l-2.121 2.121 3.439 3.439H-9.811v1h18.879l-3.439 3.44 2.121 2.121 6.061-6.061-6.061-6.06z"
                      fill="#72c7e5" width="15px" height="15px" />
                  </svg>
                  <span v-else class="the-center-nav-accordion__group-button">
                    <svg aria-hidden="true" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"
                      class="base-symbol the-header-accordion__button-icon">
                      <path d="M11 5H7V1H5v4H1v2h4v4h2V7h4V5z"></path>
                    </svg>
                  </span>
                </div>
                <div class="line" style="pointer-events: none;"></div>
              </AccordionContainerHeaderButton>
            </a>
            <AccordionContainerHeaderButton v-else :controls="'menu-sub-item-' + item.id"
              class="mobile-center-menu-mainItem" :id="'menu-sub-item-button' + item.id">
              <div class="button-wrapper">
                {{ item.name }}
                <svg v-if="item.current" xmlns="http://www.w3.org/2000/svg" viewBox="-9.811 -6.439 23.62 12.12"
                  width="25px" height="25px">
                  <path
                    d="M7.75-6.439l-2.121 2.121 3.439 3.439H-9.811v1h18.879l-3.439 3.44 2.121 2.121 6.061-6.061-6.061-6.06z"
                    fill="#72c7e5" width="15px" height="15px" />
                </svg>
                <span v-else class="the-center-nav-accordion__group-button">
                  <svg aria-hidden="true" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"
                    class="base-symbol the-header-accordion__button-icon">
                    <path d="M11 5H7V1H5v4H1v2h4v4h2V7h4V5z"></path>
                  </svg>
                </span>
              </div>
              <div class="line" style="pointer-events: none;"></div>
            </AccordionContainerHeaderButton>
            <AccordionContainerPanel :id="'menu-sub-item-' + item.id" class="mobile-center-menu-subItem-container">
              <div v-for="childItems in item.children" class="subItem-accordion-wrapper">
                <AccordionContainerHeaderButton :id="'menu-sub-item-child-button' + item.id"
                  :controls="'menu-sub-item-' + childItems.id"
                  :class="childItems.current ? 'mobile-center-menu-childItem active' : 'mobile-center-menu-childItem'">
                  <div class="button-wrapper">
                    <a :href="childItems.url" class="base-cta-featured child-item">{{ childItems.name }}
                      <span class="the-center-nav-accordion__group-button">
                        <svg xmlns="http://www.w3.org/2000/svg" id="Working" width="23px" viewBox="0 0 23 11"
                          v-if="childItems.current">
                          <polygon fill="#01246a" class="cls-1" points="23 11 5 11 0 5.5 5 0 23 0 18 5.5 23 11" />
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="-9.811 -6.439 23.62 12.12" width="25px"
                          height="25px" v-else>
                          <path
                            d="M7.75-6.439l-2.121 2.121 3.439 3.439H-9.811v1h18.879l-3.439 3.44 2.121 2.121 6.061-6.061-6.061-6.06z"
                            fill="#d43d21" />
                        </svg>
                      </span>
                    </a>
                  </div>
                </AccordionContainerHeaderButton>
                <AccordionContainerPanel :id="'menu-sub-item-' + childItems.id"
                  v-if="childItems.children.length > 0" class="mobile-center-menu-child-container">
                  {{ childItems.children }}
                </AccordionContainerPanel>
              </div>
            </AccordionContainerPanel>
          </div>
        </AccordionContainerPanel>
      </AccordionContainer>
    </div>
  </div>
</template>

<script>
import MenuItem from "./MenuItem";
import DisclosureButton from "./disclosure/DisclosureButton";
import AccordionContainer from "./accordion/AccordionContainer";
import AccordionContainerHeaderButton from "./accordion/AccordionContainerHeaderButton";
import AccordionContainerPanel from "./accordion/AccordionContainerPanel";
import SidebarDisclosure from "../components/SidebarDisclosure";

export default {
  name: 'CenterNav',
  props: {
    menuItems: {
      type: Object,
      required: true,
      default: () => ({})
    },
    isMobile: {
      type: Number,
      default: 0
    },
    menuTitle: {
      type: String,
      default: 'Menu'
    },
    cookieTrail: {
      type: Array,
      default: () => ([])
    },
    hourBlock: {
      type: Object,
      default: () => ({ is_open: false, active_blocks: [] })
    },
  },
  components: {
    MenuItem,
    DisclosureButton,
    AccordionContainer,
    AccordionContainerHeaderButton,
    AccordionContainerPanel,
    SidebarDisclosure
  },
  data() {
    return {
      open: false,
      activeMenu: {},
      parentContainer: "",
      cookieLink: ""
    }
  },
  computed: {
    hourBlocks() {
      const existing = [];
      const blocks = (this.hourBlock && this.hourBlock.active_blocks) || [];
      return blocks.filter((block) => {
        if (existing.includes(block.section_title)) {
          return false;
        }
        existing.push(block.section_title);
        return true;
      });
    }
  },
  mounted() {
    console.log('mounted');
    this.$el.addEventListener("click", this.checkClick);
    this.cookieLink = this.cookieTrail[this.cookieTrail.length - 1].title;
    this.parentContainer = this.cookieTrail[this.cookieTrail.length - 2].title;
  },
  beforeDestroy() {
    this.$el.removeEventListener("click", this.checkClick);
  },
  methods: {
    handleResponse(response) {
      console.log("this is the response", response);
      console.log(subMenu, response);
    },
    checkClick(response) {
      const testPanel = this.$refs.menuPanel;
    },
    handleMobileClick() {
      let mainElement = document.querySelector("#main");
      console.log(this);
    },
    adjustSize(response) {
      console.log(response, "this is the response");
    },
    itemClicked(response, item) {
      console.log(item.children);
      if (item.children.length > 0) {
        let currentActiveItem = document.querySelector(".center-menu__item.activeMenu");
        let childItem = document.querySelector("#menuitem-" + response);
        const subMenu = this.menuItems.items.filter((childItem) => childItem.id == response)[0];

        if (item.children.length === 0) {
          this.open = !this.open;
          this.activeMenu = {};
        } else if (this.activeMenu.ID === response) {
          this.activeMenu = subMenu;
          this.open = !this.open;
        } else {
          this.activeMenu = subMenu;
          this.open = true;
        }
        let mainElement = document.querySelector("#main");

        if (this.open) {
          mainElement.classList.add("activeMenu");
          childItem.classList.add("activeMenu");
          if (currentActiveItem) {
            currentActiveItem.classList.remove("activeMenu");
          }
        } else {
          mainElement.classList.remove("activeMenu");
          childItem.classList.remove("activeMenu");
        }
      }
    },
    toggleOverlay(item) {
      this.open = !this.open;
    },
    handleWidth(response) {
      console.log(response);
    }
  },

};
</script>

<style>
.v-enter-active,
.v-leave-active {
  height: 100px;
}

.v-enter-from,
.v-leave-to {
  height: 0px;
}

/* take this out */
</style>



// WEBPACK FOOTER //
// src/js/components/CenterNav.vue